export enum ACMTargetGroups {
	BUR = 'BUR',
	EA = 'EA',
	VER = 'VER'
}
